import { render } from "./EditContactorView.vue?vue&type=template&id=8fc96db0&scoped=true"
import script from "./EditContactorView.vue?vue&type=script&lang=js"
export * from "./EditContactorView.vue?vue&type=script&lang=js"

import "./EditContactorView.vue?vue&type=style&index=0&id=8fc96db0&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc96db0"]])

export default __exports__